// Import FC
import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import { Box } from "@mui/material";
import { useAtomValue } from "jotai";
import { baseAtom } from "../../stores/jotai/base";
import HomeSegmentCard from "./HomeSegmentCard";
import HomeSegmentContent from "./HomeSegmentContent";
import HomeSegmentTitle from "./HomeSegmentTitle";

import { useAtom } from "jotai";
import { bmcPopoverAtom } from "../../stores/jotai/bmcPopover";
import CanvasFrame from "./CanvasFrame";

import { useEffect, useState } from "react";
import { HYPOTHESIS_STATES } from "../../components/canvas/constants";
import { areAllHypothesisEmpty } from "../../util";
import HypothesisChart from "./HypothesisChart";
import ActivityFeedSegmentCardSkeleton from "./Skeleton/ActivityFeedSegmentCardSkeleton";

interface props {
  isCanvasLoading?: boolean;
  canvas?: {
    description: string;
  };
}

const ActivityFeedSegmentCard = ({ isCanvasLoading, canvas }: props) => {
  const [categoriesData, setCategoriesData] = useState({
    validated: [],
    invalidated: [],
    unresolved: []
  });
  const [bmcPopoverState] = useAtom(bmcPopoverAtom);
  const { showCanvasActivity } = bmcPopoverState;
  const base = useAtomValue(baseAtom);
  const [isChartReady, setChartReady] = useState(false);

  useEffect(() => {
    setChartReady(false);
    if (canvas) {
      const processedData = processCategories(canvas);
      setCategoriesData(processedData);

      setTimeout(() => {
        setChartReady(true);
      }, 500);
    }
  }, [canvas]);

  const processCategories = (canvas) => {
    if (!canvas?.categories)
      return { validated: [], invalidated: [], unresolved: [] };

    const validateEntries = [];
    const inValidateEntries = [];
    const unresolvedEntries = [];

    canvas?.categories?.forEach((cat) => {
      cat?.entries?.forEach((entry) => {
        if (entry.state !== HYPOTHESIS_STATES.DELETED) {
          if (entry.state === HYPOTHESIS_STATES.VALIDATED) {
            validateEntries.push(entry);
          } else if (entry.state === HYPOTHESIS_STATES.INVALIDATED) {
            inValidateEntries.push(entry);
          } else if (
            !entry.state ||
            entry.state === HYPOTHESIS_STATES.HYPOTHESIS
          ) {
            unresolvedEntries.push(entry);
          }
        }
      });
    });

    return {
      validated: validateEntries,
      invalidated: inValidateEntries,
      unresolved: unresolvedEntries
    };
  };
  const isBaseLoading = Object.keys(base.user || {})?.length === 0;
  return (
    <>
      {isBaseLoading || isCanvasLoading ? (
        <ActivityFeedSegmentCardSkeleton />
      ) : (
        <HomeSegmentCard>
          <HomeSegmentTitle>
            <ViewQuiltOutlinedIcon />
            <Box
              component="span"
              sx={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden"
              }}
            >
              Canvas: {canvas?.description}
            </Box>
          </HomeSegmentTitle>
          {!isChartReady ? (
            <ActivityFeedSegmentCardSkeleton showHomeSegmentTitle={false} />
          ) : (
            <HomeSegmentContent>
              {isChartReady &&
              areAllHypothesisEmpty(categoriesData) &&
              showCanvasActivity ? (
                <HypothesisChart hypothesisInUse={categoriesData} />
              ) : (
                <CanvasFrame canvasData={canvas}/>
              )}
            </HomeSegmentContent>
          )}
        </HomeSegmentCard>
      )}
    </>
  );
};

export default ActivityFeedSegmentCard;
